import type { User } from '@supabase/supabase-js'

/**
 * The signed-in user as the server verified it: seeded from the (main) layout
 * snapshot and kept in sync by AuthContext. Replaces browser
 * `supabase.auth.getUser` calls, which no longer work – the browser client runs
 * in `accessToken` mode (src/lib/supabase/client.ts).
 */
let current: User | null = null

export function getCurrentUser(): User | null {
  return current
}

export function setCurrentUser(user: User | null): void {
  current = user
}
